import Cookies from 'js-cookie';
import React, { createContext, useState, useRef } from 'react';
import { useEffect } from 'react';
import useWindowDimensions from '../functions/UseWindowDimensions';
import CookieFunction from '../functions/cookieFunction';

export const AdminContext = createContext();

import toEnglishDigits from '../functions/toEnglishDigits';

const AdminContextProvider = (props) => {
  const [login, setLogin] = useState(false);

  const [trigger, setTrigger] = useState('');
  const [themeColor, setThemeColor] = useState('white');
  const [themeMode, setThemeMode] = useState('dark');

  const [countries, setCountries] = useState([]);
  const [videoChatSize, setVideoChatSize] = useState('0');
  const [videoType, setVideoType] = useState([]);
  const [fileType, setFileType] = useState([]);

  const [userChannelId, setUserChannelId] = useState('');

  const [privateUser, setPrivateUser] = useState({ ids: [], content: '' });
  const [privateUsers, setPrivateUsers] = useState([]);

  const [userId, setUserId] = useState('');
  const [openCreateGroup, setOpenCreateGroup] = useState(false);
  const [openNotificationModalError, setopenNotificationModalError] =
    useState(false);

  const [notificationModal, setNotificationModal] = useState(null);
  const [activeMenuFile, setActiveMenuFile] = useState({ subMenu: 1 });
  const [isElectron, setIsElectron] = useState(true);
  const [notificationText, setNotificationText] = useState({
    title: '',
    description: '',
    guide: '',
  });

  const [imageType, setImageType] = useState([]);
  const [srtType, setSrtType] = useState([]);

  const [imageSize, setImageSize] = useState([]);
  const [srtSize, setSrtSize] = useState([]);
  const [videoUploaded, setVideoUploaded] = useState(false);

  const [correctTypeSrt, setCorrectTypeSrt] = useState('');
  const [searchValue, setSearchValue] = useState('');

  const isMobileBase =
    typeof window !== 'undefined' && window.innerWidth <= 800;
  const isDesktopBase =
    typeof window !== 'undefined' && window.innerWidth > 800;
  const [isMobile, setIsMobile] = useState(null);
  const [isDesktop, setIsDesktop] = useState(null);
  const [content, setContent] = useState({});
  const [direction, setDirection] = useState('ltr');
  const [lang, setLang] = useState('en');
  const [updateSocket, setUpdateSocket] = useState();
  const [activeMessage, setActiveMessage] = useState('');
  const [activeMessageAudio, setActiveMessageAudio] = useState('');

  const [openShare, setOpenShare] = useState(false);
  const [userChosenForShare, setUserChosenForShare] = useState({});
  const [activeAudio, setActiveAudio] = useState();
  const [openSettingModal, setOpenSettingModal] = useState(false);
  const [backScale, setBackScale] = useState();
  const [groupState, setGroupState] = useState();
  const [sharedUserClicked, setSharedUserClicked] = useState();
  const [forwardMessages, setForwardMessages] = useState();
  const [previousChannelId, setPreviousChannelId] = useState('');
  const { width } = useWindowDimensions();

  useEffect(() => {
    // setUrlPath(window.location.href);
    //setActiveMenu('/' + window.location.pathname.split('/')?.[1]);
    if (
      CookieFunction('get', 'ochattColor') !== null &&
      CookieFunction('get', 'ochattColor') != undefined
    ) {
      setThemeColor(CookieFunction('get', 'ochattColor'));
    } else {
      setThemeColor('green');
      // Cookies.set('ochattColor', 'white');
    }
    if (
      CookieFunction('get', 'ochattMode') !== null &&
      CookieFunction('get', 'ochattMode') != undefined
    ) {
      setThemeMode(CookieFunction('get', 'ochattMode'));
    } else {
      setThemeMode('dark');
      // Cookies.set('ochattColor', 'white');
    }
    if (
      CookieFunction('get', 'backScale') !== null &&
      CookieFunction('get', 'backScale') != undefined
    ) {
      setBackScale(CookieFunction('get', 'backScale'));
    } else {
      setBackScale('40');
      // Cookies.set('ochattColor', 'white');
    }
    setIsMobile(isMobileBase);
    setIsDesktop(isDesktopBase);
    if (CookieFunction('get', 'ochattToken') != undefined) {
      setLogin(CookieFunction('get', 'ochattToken'));
    }
  }, []);

  useEffect(() => {
    if (width < 650) {
      setIsDesktop(false);
      setIsMobile(true);
    } else {
      setIsDesktop(true);
      setIsMobile(false);
    }
  }, [width]);
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + '-' + dd + '-' + yyyy;
  let shamsiDate = new Date(today).toLocaleString('fa-IR', {
    day: '2-digit',
    month: 'numeric',
    year: 'numeric',
  });
  let English = toEnglishDigits(shamsiDate);
  const [userInfo, setUserInfo] = useState({
    user: { birthDate: English, genderId: '', email: '', userCategory: [] },
  });
  const [showUsers, setShowUsers] = useState(true);
  const [activeUser, setActiveUser] = useState();
  const [sharedUser, setSharedUser] = useState();

  const [showSearch, setShowSearch] = useState(false);
  const [showFirstMessage, setShowFirstMessage] = useState('');
  const [playing, setPlaying] = useState(false);
  const [seekValue, setSeekValue] = useState(0);
  const [openZoomModal, setOpenZoomModal] = useState(false);
  const [zoomContent, setZoomeContent] = useState();
  const [downloadedFiles, setDownloadedFiles] = useState([]);

  const [showFiles, setShowFiles] = useState(false);
  const [openBox, setopenBox] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const [showAbsolute, setShowAbsolute] = useState(false);
  const [bg, setBg] = useState(0);
  const [isLogin, setIsLogin] = useState(false);
  const [openUpdateProfile, setOpenUpdateProfile] = useState(false);
  const [showUserInfo, setShowUserInfo] = useState();

  // const [headerInfo,setHeaderInfo] = useState({  title = 'Clipsho Chat App',
  // src = false,
  // local = true,})
  useEffect(() => {
    const token = CookieFunction('get', 'ochattToken');
    if (token == undefined || !token) {
      setIsLogin(false);
    } else {
      setIsLogin(true);
    }
    // setIsLogin()
  }, []);

  const [followButtonState, setFollowButtonState] = useState('/');
  const [videoListData, setVideoListData] = useState({
    mode: null,
    videos: [],
    videosExtra: [],
  });
  const [switchOn, setSwitchOn] = useState(true);
  const [shuffleOn, setShuffleOn] = useState(false);
  const [repeatPlaylistOn, setRepeatPlaylistOn] = useState(false);
  const [userActions, setUserActions] = useState({
    userInterest: [],
    userLike: [],
  });
  const [playList, setPlayList] = useState(false);
  const [playListArray, setPlayListArray] = useState([]);

  const [videoName, setVideoName] = useState('');
  const [mainVideoSrc, setMainVideoSrc] = useState('');
  const [downloadVideoSrc, setDownloadVideoSrc] = useState('');
  const [musicSrc, setMusicSrc] = useState([]);
  const [videoSize, setVideoSize] = useState('w-2/3');
  const [autoPlayArray, setautoPlayArray] = useState([]);
  const [changedThisVideoBookmark, setChangedThisVideoBookmark] = useState({
    listVideo: { id: '', active: false },
    thisVideo: { id: '', active: false },
  });

  const defaultLocaleObj = {
    locale: 'en-US',
    name: 'English',
    native_name: 'English',
  };

  let initialAppState = {
    videos: [],
    current_step: 2,
    current_sub_step: '',
    video_url: '',
    file: null,
    user: null,
    socket: null,
    current_locale: defaultLocaleObj,
    current_locale_object: {
      locale: 'en-US',
      native_name: 'English',
    },
    video_details: {},
    notifications: [],
  };
  const [appState, setAppState] = useState(initialAppState);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      initialAppState = {
        ...initialAppState,
        current_locale: defaultLocaleObj,
      };
    }
  }, []);

  const updateAppState = (newState) => {
    let { notifications } = appState;

    // If notification object exist add to notifications array
    if ('notification' in newState) {
      // Add extra properties to notification object to control it
      const updateNotificationState = {
        ...newState.notification,
        show: true,
        autohide:
          'autohide' in newState.notification
            ? newState.notification.autohide
            : true,
        delay:
          'delay' in newState.notification
            ? newState.notification.delay
            : 10000,
      };

      // Create new notifications array
      notifications = [...appState.notifications, updateNotificationState];

      delete newState.notification;
    }
    return setAppState({ ...appState, ...newState, notifications });
  };

  const updateNotification = (newNotificationState, index) => {
    const notifications = [...appState.notifications];
    notifications[index] = { ...notifications[index], ...newNotificationState };

    return setAppState({
      ...appState,
      notifications,
    });
  };

  return (
    <AdminContext.Provider
      value={{
        trigger,
        setTrigger,

        notificationModal,
        setNotificationModal,

        isMobile,
        isDesktop,

        login,
        setLogin,

        themeColor,
        setThemeColor,

        themeMode,
        setThemeMode,

        privateUser,
        setPrivateUser,

        userId,
        setUserId,

        openNotificationModalError,
        setopenNotificationModalError,

        notificationText,
        setNotificationText,

        imageType,
        setImageType,
        srtType,
        setSrtType,
        imageSize,
        setImageSize,
        srtSize,
        setSrtSize,
        correctTypeSrt,
        setCorrectTypeSrt,

        userInfo,
        setUserInfo,

        videoChatSize,
        setVideoChatSize,
        videoType,
        setVideoType,
        fileType,
        setFileType,
        userChannelId,
        setUserChannelId,
        showUsers,
        setShowUsers,
        activeUser,
        setActiveUser,
        direction,
        setDirection,
        content,
        setContent,
        lang,
        setLang,
        updateSocket,
        setUpdateSocket,
        privateUsers,
        setPrivateUsers,
        activeMessage,
        setActiveMessage,
        openShare,
        setOpenShare,
        userChosenForShare,
        setUserChosenForShare,
        sharedUser,
        setSharedUser,

        showSearch,
        setShowSearch,
        showFirstMessage,
        setShowFirstMessage,

        activeAudio,
        setActiveAudio,

        playing,
        setPlaying,
        seekValue,
        setSeekValue,

        openZoomModal,
        setOpenZoomModal,
        zoomContent,
        setZoomeContent,

        downloadedFiles,
        setDownloadedFiles,

        showFiles,
        setShowFiles,

        openBox,
        setopenBox,
        openMenu,
        setOpenMenu,
        showAbsolute,
        setShowAbsolute,

        openSettingModal,
        setOpenSettingModal,

        bg,
        setBg,

        isLogin,
        setIsLogin,

        backScale,
        setBackScale,

        openCreateGroup,
        setOpenCreateGroup,

        groupState,
        setGroupState,

        sharedUserClicked,
        setSharedUserClicked,

        openUpdateProfile,
        setOpenUpdateProfile,

        activeMenuFile,
        setActiveMenuFile,

        activeMessageAudio,
        setActiveMessageAudio,

        forwardMessages,
        setForwardMessages,

        isElectron,
        setIsElectron,
        searchValue,
        setSearchValue,

        showUserInfo,
        setShowUserInfo,

        previousChannelId,
        setPreviousChannelId,

        appState,
        updateAppState,
        updateNotification,

        followButtonState,
        setFollowButtonState,
        videoListData,
        shuffleOn,
        setShuffleOn,
        switchOn,
        setSwitchOn,
        setVideoListData,
        userActions,
        setUserActions,
        playList,
        setPlayList,
        playListArray,
        setPlayListArray,
        videoName,
        setVideoName,
        mainVideoSrc,
        setMainVideoSrc,
        musicSrc,
        setMusicSrc,
        videoSize,
        setVideoSize,
        autoPlayArray,
        setautoPlayArray,
        changedThisVideoBookmark,
        setChangedThisVideoBookmark,
        repeatPlaylistOn,
        setRepeatPlaylistOn,
        downloadVideoSrc,
        setDownloadVideoSrc,
        videoUploaded,
        setVideoUploaded,

        countries,
        setCountries,
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
};
export default AdminContextProvider;
